import React from "react";

export default function FeatureCard({ feature, onClick }) {
  const Icon = feature.icon;

  return (
    <div
      onClick={onClick}
      className="relative flex flex-col items-center text-center p-6 md:p-8 bg-white rounded-xl shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer group border border-snaptrix-gray-200 h-full overflow-hidden"
      role="button"
      tabIndex={0}
      aria-label={`Learn more about ${feature.name}`}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {/* Colorful accent bar at top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-snaptrix-blue-600 via-purple-500 to-pink-500 group-hover:h-2 transition-all duration-300" />
      
      <div className="mb-4 p-4 bg-gradient-to-br from-snaptrix-blue-50 to-snaptrix-blue-100 rounded-full group-hover:from-snaptrix-blue-100 group-hover:to-snaptrix-blue-200 transition-all duration-300 shadow-md group-hover:shadow-lg">
        <Icon className="text-snaptrix-blue-600 group-hover:scale-110 transition-transform duration-300 text-4xl md:text-5xl" aria-hidden="true" />
      </div>
      <h3 className="text-xl md:text-2xl font-bold mb-3 text-snaptrix-gray-700">
        {feature.name}
      </h3>
      <p className="text-snaptrix-gray-600 leading-relaxed text-sm md:text-base">
        {feature.shortDescription}
      </p>
      <span className="mt-4 text-snaptrix-blue-600 text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Learn More →
      </span>
    </div>
  );
}
